import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { user, loading, initializing } = useAuth();

  // 초기 로딩 동안에는 아무것도 렌더하지 않음 (깜빡임 방지)
  if (initializing || loading) {
    return null;
  }

  // 미인증 시 로그인으로 이동, 원래 경로를 state.from에 보존
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute; 